// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1uvWA","requiredAsterisk":"Info_requiredAsterisk__LDvkU"};